export default __webpack_public_path__ + "static/media/twitter.a26273c5.svg";